import { jsonldJobCompany } from './JsonldStore';

export const updateJsonldJobCompany = (value) => jsonldJobCompany.update((oldValue) => value);
